<template>
    <div>

        <div v-if="$page.props.flash && $page.props.flash.success && show" class="fixed z-50 inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
            <!--
              Notification panel, show/hide based on alert state.
          
              Entering: "transform ease-out duration-300 transition"
                From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                To: "translate-y-0 opacity-100 sm:translate-x-0"
              Leaving: "transition ease-in duration-100"
                From: "opacity-100"
                To: "opacity-0"
            -->
            <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div class="p-4">
                    <div class="flex items-start">
                        <div class="flex-shrink-0">
                            <!-- Heroicon name: check-circle -->
                            <svg class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div class="ml-3 w-0 flex-1 pt-0.5">
                            <p class="text-sm font-medium text-gray-900">
                                {{ $page.props.flash.success }}
                            </p>
                        </div>
                        <div class="ml-4 flex-shrink-0 flex">
                            <button @click="show=false"  class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <span class="sr-only">Close</span>
                                <!-- Heroicon name: x -->
                                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
        
<!--        <div class="bg-indigo-600" v-if="$page.props.flash && $page.props.flash.success && show">-->
<!--            <div  class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">-->
<!--                <div class="flex items-center justify-between flex-wrap">-->
<!--                    <div class="w-0 flex-1 flex items-center">-->
<!--        <span class="flex p-2 rounded-lg bg-indigo-800">-->
<!--          <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
<!--            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />-->
<!--          </svg>-->
<!--        </span>-->
<!--                        <p class="ml-3 font-medium text-white truncate">-->
<!--                            {{ $page.props.flash.success }}-->
<!--                        </p>-->
<!--                    </div>-->


<!--                    <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">-->
<!--                        <button type="button" @click="show=false" class="-mr-1 flex p-2 rounded-md hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2">-->
<!--                            <span class="sr-only">Dismiss</span>-->
<!--                            &lt;!&ndash; Heroicon name: x &ndash;&gt;-->
<!--                            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
<!--                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />-->
<!--                            </svg>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->


        <div v-if="((($page.props.flash && $page.props.flash.error) || ($page.props.errors && Object.keys($page.props.errors).length > 0)) && show)" class="fixed z-50 inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
            <!--
              Notification panel, show/hide based on alert state.
          
              Entering: "transform ease-out duration-300 transition"
                From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                To: "translate-y-0 opacity-100 sm:translate-x-0"
              Leaving: "transition ease-in duration-100"
                From: "opacity-100"
                To: "opacity-0"
            -->
            <div class="max-w-sm w-full bg-red-600 shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div class="p-4">
                    <div class="flex items-start">
                        <div class="flex-shrink-0">
                            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                            
                        </div>
                        <div class="ml-3 w-0 flex-1 pt-0.5">
                            <p v-if="($page.props.flash && $page.props.flash.error)" class="text-sm font-medium text-white">
                                {{ $page.props.flash.error }}
                            </p>
                            <template v-else>
                                <p v-for="id in Object.keys($page.props.errors)" :key="id" class="text-sm font-medium text-white">
                                    {{ $page.props.errors[id] }}
                                </p>
                            </template>
                            
                            
                        </div>
                        <div class="ml-4 flex-shrink-0 flex">
                            <button @click="show=false" class="bg-red-900 rounded-md inline-flex text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <span class="sr-only">Close</span>
                                <!-- Heroicon name: x -->
                                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
<!--        <div class="bg-red-600" v-if="(($page.props.flash && $page.props.flash.error) || ($page.props.errors && Object.keys($page.props.errors).length > 0) && show)">-->
<!--            <div  class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">-->
<!--                <div class="flex items-center justify-between flex-wrap">-->
<!--                    <div class="w-0 flex-1 flex items-center">-->
<!--        <span class="flex p-2 rounded-lg bg-red-800">-->
<!--          &lt;!&ndash; Heroicon name: speakerphone &ndash;&gt;-->
<!--          <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">-->
<!--              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />-->
<!--            </svg>-->
<!--        </span>-->
<!--                        <p v-if="($page.props.flash && $page.props.flash.error)" class="ml-3 font-medium text-white truncate">-->
<!--                            {{ $page.props.flash.error }}-->
<!--                        </p>-->
<!--                        <template v-else>-->
<!--                            <p v-for="id in Object.keys($page.props.errors)" :key="id" class="ml-3 font-medium text-white truncate">-->
<!--                                {{ $page.props.errors[id] }}-->
<!--                            </p>-->
<!--                        </template>-->
<!--                    </div>-->


<!--                    <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">-->
<!--                        <button type="button" @click="show=false" class="-mr-1 flex p-2 rounded-md hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2">-->
<!--                            <span class="sr-only">Dismiss</span>-->
<!--                            &lt;!&ndash; Heroicon name: x &ndash;&gt;-->
<!--                            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
<!--                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />-->
<!--                            </svg>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: true,
        }
    },
    watch: {
        '$page.props.flash.success': {
            handler() {
                this.show = true
                if (this._flasher) {
                    clearTimeout(this._flasher);
                }
                this._flasher = setTimeout(() => {
                    this.show = false;
                }, 4000);
            },
            deep: true,
        },
        '$page.props.errors': {
            handler() {
                this.show = true
                if (this._flasher) {
                    clearTimeout(this._flasher);
                }
                this._flasher = setTimeout(() => {
                    this.show = false;
                }, 4000);
            },
            deep: true,
        },
    },
}
</script>
